import * as React from "react";
import CONSTS from "../../consts";
import StoreHours from "./store-hours";
export default class DescDefault extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let supplier = this.props.supplier;
        let province = supplier.Province ? supplier.Province.toUpperCase() : null;
        let postal = supplier.PostalCode ? supplier.PostalCode.toUpperCase() : null;
        return (React.createElement("div", { className: "desc-wrap" },
            React.createElement("h1", null,
                supplier.Name,
                React.createElement("div", null,
                    supplier.AHLAMember ? React.createElement("img", { src: `${CONSTS.STORAGEURL}/${CONSTS.LOGOCONTAINER}/AHLA Logo.jpg` }) : null,
                    supplier.ALSAMember ? React.createElement("img", { src: `${CONSTS.STORAGEURL}/${CONSTS.LOGOCONTAINER}/ALSA Logo.jpg` }) : null)),
            React.createElement("div", { className: "desc-default" },
                React.createElement("div", { className: "section" },
                    React.createElement("div", { className: "field" },
                        React.createElement("p", { className: "header" }, "Address"),
                        React.createElement("div", { className: "content" },
                            React.createElement("span", null, supplier.StreetAddress),
                            " ",
                            React.createElement("br", null),
                            React.createElement("span", null, supplier.City),
                            ", ",
                            province,
                            " ",
                            postal)),
                    supplier.PaymentMethods &&
                        React.createElement("div", { className: "field" },
                            React.createElement("p", { className: "header" }, "Payment Methods"),
                            React.createElement("div", { className: "content" },
                                "We accept ",
                                supplier.PaymentMethods,
                                ".")),
                    supplier.EstablishmentType &&
                        React.createElement("div", { className: "field" },
                            React.createElement("p", { className: "header" }, "Establishment Type"),
                            React.createElement("div", { className: "content" }, supplier.EstablishmentType))),
                React.createElement("div", { className: "section" },
                    React.createElement("div", { className: "field" },
                        React.createElement("p", { className: "header" }, "Phone"),
                        React.createElement("div", { className: "content" }, supplier.Phone)),
                    supplier.Email &&
                        React.createElement("div", { className: "field" },
                            React.createElement("p", { className: "header" }, "Email"),
                            React.createElement("div", { className: "content" }, supplier.Email)),
                    supplier.Website &&
                        React.createElement("div", { className: "field" },
                            React.createElement("p", { className: "header" }, "Main Website"),
                            React.createElement("div", { className: "content" }, supplier.Website))),
                React.createElement("div", { className: "section" },
                    React.createElement("div", { className: "field" },
                        React.createElement("p", { className: "header" }, "Hours"),
                        React.createElement("div", { className: "content" },
                            React.createElement(StoreHours, { supplier: this.props.supplier })))))));
    }
}
;
//# sourceMappingURL=desc-default.js.map